/* eslint-disable unicorn/numeric-separators-style */
import { StoryData } from '@cinch-nx/data-storyblok'
import { PolicyPageStoryContent } from '../types/policy-page'

export const cookiePolicyFallback: StoryData<PolicyPageStoryContent> = {
  name: 'Cookie Policy',
  created_at: '2022-08-05T13:01:41.370Z',
  published_at: '2025-08-20T15:31:17.552Z',
  id: 172710721,
  uuid: '085f4cf4-9697-4dcd-aca7-565bffe0224f',
  content: {
    _uid: '64be0768-6623-4a56-863c-53ffdf1856d1',
    body: {
      type: 'doc',
      content: [
        {
          type: 'paragraph',
        },
      ],
    },
    title: 'Cookie Policy',
    clauses: [],
    component: 'PolicyPage',
    cookiePolicy: [
      {
        _uid: '782d0f9a-5203-4a3d-8127-a9af6bfaae6f',
        intro: {
          type: 'doc',
          content: [
            {
              type: 'paragraph',
              content: [
                {
                  text: 'Last updated: 20 August 2025',
                  type: 'text',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'We use cookies to make our websites more user-friendly or enable them to work effectively on your machine. A cookie is a small file, which will be placed on your device. Find out about the main types of cookies we use and what we use them for below. If you want to know how to delete cookies, go to our deleting cookies section. ',
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'Some cookies are essential to ensure the security of our sites, to allow you to log in to your account, and to provide functionality such as adding a car into your basket. These cookies are set automatically when you visit the site.',
                  type: 'text',
                  marks: [
                    {
                      type: 'styled',
                      attrs: {
                        class: '',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'We will always give you the chance to accept or decline non-essential cookies beyond the choice you make when you first see our cookie banner.',
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'The data we collect using cookies helps us understand our customers better to provide a more focused user experience. Using the knowledge of your previous visits to our website, cinch can enhance subsequent visits by tailoring our content to match your requirements. ',
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'We also work with advertisers, publishers and social media sites to provide relevant information and content to you. In addition to cookies, if you give us consent we also use web beacons, web tags and tracking pixels. If we share personal data with other parties, we encrypt the personal data to keep it secure and prevent unauthorised use by anyone else. ',
                  type: 'text',
                },
              ],
            },
          ],
        },
        title: '',
        content: {
          type: 'doc',
          content: [
            {
              type: 'paragraph',
              content: [
                {
                  text: 'This button allows you to change your cookie preferences on the website only. If you are using the cinch app, you can change your preferences using the settings under My profile.',
                  type: 'text',
                  marks: [
                    {
                      type: 'bold',
                    },
                    {
                      type: 'styled',
                      attrs: {
                        class: '',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: ' ',
                  type: 'text',
                  marks: [
                    {
                      type: 'styled',
                      attrs: {
                        class: '',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'If you’re using the cinch app',
                  type: 'text',
                  marks: [
                    {
                      type: 'bold',
                    },
                    {
                      type: 'styled',
                      attrs: {
                        class: '',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'In addition to the cookies listed on this page, we use the following technologies on our app:',
                  type: 'text',
                  marks: [
                    {
                      type: 'styled',
                      attrs: {
                        class: '',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: '•          Datadog – essential monitoring of the app performance and usage',
                  type: 'text',
                  marks: [
                    {
                      type: 'styled',
                      attrs: {
                        class: '',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: '•          Adobe - general analytics',
                  type: 'text',
                  marks: [
                    {
                      type: 'styled',
                      attrs: {
                        class: '',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: '•          Segment - marketing analytics',
                  type: 'text',
                  marks: [
                    {
                      type: 'styled',
                      attrs: {
                        class: '',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'We’ll always ask permission before setting non-essential cookies, but you are also able to update your preferences at any time by visiting the Settings in the app itself. Please note the ‘Edit Cookie Preferences’ button below is just for cookies set by the main website on your browser, so doesn’t update the app.  ',
                  type: 'text',
                  marks: [
                    {
                      type: 'styled',
                      attrs: {
                        class: '',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'Updating this notice',
                  type: 'text',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'This Cookie Policy may change from time to time due to developments in technology or business, new services or when any legal guidance is published.',
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: ' ',
                  type: 'text',
                  marks: [
                    {
                      type: 'styled',
                      attrs: {
                        class: '',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'heading',
              attrs: {
                level: 4,
              },
              content: [
                {
                  text: 'Cookies used on the cinch site',
                  type: 'text',
                  marks: [
                    {
                      type: 'styled',
                      attrs: {
                        class: '',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: "The cookies listed below are the cookies used on our site, if they are a third party clicking on the company’s name will take you to the third party's privacy policy where more information about the information they gather can be found.",
                  type: 'text',
                },
              ],
            },
          ],
        },
        component: 'CookiePolicySection',
        buttonText: 'Edit Cookie Preferences',
        tableSection: [
          {
            _uid: 'dca58c47-d3aa-4e9e-ba7f-5d08f055ea94',
            table: {
              tbody: [
                {
                  _uid: '8ddb1109-5b85-481f-86f3-14caeff27adc',
                  body: [
                    {
                      _uid: 'b00fdea1-1e17-4f37-b865-2da3516d28c7',
                      value: '_dd_s',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ac65fffb-1f69-4a2b-be4c-c925add91c5b',
                      value: 'Datadog',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c470f4a0-9536-4cfa-87d7-d704a2a8ae29',
                      value: 'https://www.datadoghq.com/legal/privacy/',
                      component: '_table_col',
                    },
                    {
                      _uid: '3093d860-65ff-4123-91f0-5a9c16fb6484',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '6b67dfef-356a-4ece-97c7-48e3afea7cb1',
                      value: 'Error handling',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f0a7dc46-2bc5-434a-b40e-20346334fd74',
                      value: '15 minutes',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'dadcfe8f-3eba-4c42-a4d4-68d18e76b11e',
                  body: [
                    {
                      _uid: 'c5da78ba-7ce4-4c15-8497-2ff65845d582',
                      value: 'dd_site_test_*',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f2311ec8-115e-4ee9-b595-910d5d4a744a',
                      value: 'Datadog',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c7622ea2-23df-4c20-930f-dad63ace9318',
                      value: 'https://www.datadoghq.com/legal/privacy/',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c053898e-439d-4e92-b83b-515758073bba',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd9967ee5-c669-476f-9589-c8b8a5fd0fb8',
                      value:
                        'Temporary cookie used to test for cookie support. ',
                      component: '_table_col',
                    },
                    {
                      _uid: '23ddc0dd-803a-4c28-ace4-e53624fd8708',
                      value: '1 second',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'db63e3c4-1a5b-4e3e-bedd-690fda92b910',
                  body: [
                    {
                      _uid: '958673e9-a0ac-470a-8661-84bc9ebfb02e',
                      value: 'dd_cookie_test_*',
                      component: '_table_col',
                    },
                    {
                      _uid: '2ce57d2a-12ed-4b33-89ba-ad8e61124a15',
                      value: 'Datadog',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b0cfcc34-ea04-4e12-b862-4c841f6f2965',
                      value: 'https://www.datadoghq.com/legal/privacy/',
                      component: '_table_col',
                    },
                    {
                      _uid: '649e9312-34b9-4cf0-b770-f96f43631a08',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'dda7c43c-3d91-4867-a44d-763b9aeba0a3',
                      value:
                        'Temporary cookie used to test for cookie support. ',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f2eaba7f-98a4-4350-9996-a2090886db50',
                      value: '1 second',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '0945dc2e-cda5-4c8d-b660-10f91bc6e818',
                  body: [
                    {
                      _uid: '5c08a20b-bb24-4e53-a90e-57ed78658ebc',
                      value: '__cf_bm',
                      component: '_table_col',
                    },
                    {
                      _uid: '219fea80-c0e5-40a7-a343-e9d2a59222dc',
                      value: 'Cloudflare',
                      component: '_table_col',
                    },
                    {
                      _uid: '7cdbdad0-797d-4901-95f7-c48f434d4611',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '6c394c1c-a356-4eac-bf9a-392f0e36be1b',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '5a729bfb-47d0-4a80-8a66-f2e90877afe7',
                      value: 'Cloudflare cookie to protect website from bots.',
                      component: '_table_col',
                    },
                    {
                      _uid: '6b9b51f9-2ebd-40a4-911e-50fcd6787e1e',
                      value: '30 minutes',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'bf6ec8bb-1176-4b71-a074-daf6cd838995',
                  body: [
                    {
                      _uid: 'd7b1628c-884e-4544-b8ea-0bdfb85c4e5d',
                      value: 'auth0',
                      component: '_table_col',
                    },
                    {
                      _uid: '795df4de-602d-4859-9d97-692f7f7a290b',
                      value: 'Auth0',
                      component: '_table_col',
                    },
                    {
                      _uid: '510525aa-e3b1-4627-8957-a4d2bb5b196e',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '82d83552-64cf-45d6-b91f-d9b97c7f3ed2',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '52c9f114-3173-45cc-a6e8-7a9db39c75e5',
                      value: 'Used to implement the Auth0 session layer.',
                      component: '_table_col',
                    },
                    {
                      _uid: '6a836a77-b18e-4407-b451-2020df706005',
                      value: '3 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'a9075527-36e8-493b-ba80-e336c2f6645f',
                  body: [
                    {
                      _uid: 'cd8874d2-cc41-4353-8627-894f08d2e086',
                      value: 'auth0_compat',
                      component: '_table_col',
                    },
                    {
                      _uid: '0cd539d6-955d-48ce-af3a-ec91faaa7aa3',
                      value: 'Auth0',
                      component: '_table_col',
                    },
                    {
                      _uid: '5c1cbea9-2ca3-4194-ae4b-012ac8ebac82',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '9f1efeb4-c1d2-4626-94f2-389eac1580d2',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a8e96881-f3fe-4660-b7e3-da2f322e39ae',
                      value:
                        "Fallback cookie used for single sing-on browsers that don't support the sameSite=None attribute",
                      component: '_table_col',
                    },
                    {
                      _uid: 'ce993864-a723-4319-b32a-887f48f1540e',
                      value: '3 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '63e4b0f7-0b15-4fc6-ae10-6bd96603a1c1',
                  body: [
                    {
                      _uid: 'b4985c89-a6b6-439b-a47d-6a0b9fef5f99',
                      value: 'did',
                      component: '_table_col',
                    },
                    {
                      _uid: '7b5fd2f1-6356-45db-83ee-3f00f742e16e',
                      value: 'Auth0',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a384f526-f254-457a-a9bb-e6da4ba01e28',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '6694ce84-7241-41e4-8d8e-926018ff6fdf',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '64a1b62a-ab41-446b-85a0-90eb9c05c048',
                      value: 'Device identification for attack protection.',
                      component: '_table_col',
                    },
                    {
                      _uid: '0bb46a74-cee7-4b0a-8c94-4e3d6ffe6323',
                      value: '1 year',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '57eda2bf-196a-4284-a9f6-6f4293e4ce3e',
                  body: [
                    {
                      _uid: '5c63cdea-1afc-4a7a-8d51-e12ba95899ff',
                      value: 'did_compat',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c7abd367-eaf5-467d-bbd4-834b55542a07',
                      value: 'Auth0',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f0f4c2f3-5da6-40ab-9be4-72c0831a7a8b',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '88076c79-37f1-417b-99c8-81c4715c1057',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '2fa058f5-80eb-4e2a-94f7-fa140f1d71b1',
                      value:
                        "Fallback cookie for anomaly detection on browsers that don't support the sameSite=None attribute.",
                      component: '_table_col',
                    },
                    {
                      _uid: 'e8e19215-eb5d-47ba-a298-ab00abc1968b',
                      value: '1 year',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'a8aab0c1-9277-4bbe-be3b-9a902385e1e5',
                  body: [
                    {
                      _uid: 'e410fbf5-f410-44ff-8877-551065312739',
                      value: 'tracking-preferences',
                      component: '_table_col',
                    },
                    {
                      _uid: '49df50b5-1e45-42aa-95d0-2d9aa81effbd',
                      value: 'Segment',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd12e5a17-98d0-405b-8aff-3225928be466',
                      value: 'https://www.twilio.com/legal/privacy',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ab4f5211-60aa-485d-9eed-fb0857d05f5e',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '9532c1a0-03bb-4be7-88fa-eeb1970f6d70',
                      value: "used to store a user's tracking preferences",
                      component: '_table_col',
                    },
                    {
                      _uid: '514f6bb7-ae9d-42a2-81d6-23b9693223c7',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '7de7b251-bf0b-419f-86cc-6673e8d7bd91',
                  body: [
                    {
                      _uid: '1726f4b6-006c-44a8-9001-f9d076a509d1',
                      value:
                        'oxford-user:https://identity-production.cinch.co.uk:fe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c58724eb-1aa2-41e2-a305-a59a7fccda14',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '9357c65d-ef53-40cd-90c2-d424a13bf99f',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '6776b732-3424-4da1-abdf-277a2caf5923',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fbbf562f-220a-42a9-ab0a-89346721a44e',
                      value:
                        'This allows us to remember who you are once you have logged in',
                      component: '_table_col',
                    },
                    {
                      _uid: '74b7b402-27ad-4270-8d48-d618a60f7e98',
                      value: '3 hours',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '9a785170-f89d-4a83-ad33-3d31be059bb0',
                  body: [
                    {
                      _uid: '4e3e3226-7fc8-45c2-b34b-2ebd8415a660',
                      value: 'cp',
                      component: '_table_col',
                    },
                    {
                      _uid: '3366f98b-0839-498c-9c41-26fe712e2dac',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '7f72b384-c878-4e98-a418-63a658ad3229',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '6cc15ca9-0d66-4fdd-bbda-57b507a69653',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '804b7c38-c2cb-48f0-96f2-217e967818b1',
                      value: "used to store a user's cookie preferences",
                      component: '_table_col',
                    },
                    {
                      _uid: 'b5efd2d8-c51d-4339-9b7f-aba76820c71b',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'a135328c-2cc1-4420-944a-26eaa4101376',
                  body: [
                    {
                      _uid: '985e989c-30e7-40dc-b4cf-92c7558cc11e',
                      value: 'active-lenders',
                      component: '_table_col',
                    },
                    {
                      _uid: '09fe3393-4ced-423f-90fe-77aeadbf11dd',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd270aaa9-da47-42bd-b63d-2cffcd523d5c',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd0fd468c-7747-492b-b514-729a88d8b72e',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '2d11b966-5e23-4571-9ee7-23f4650dde3a',
                      value:
                        'This cookie stores the current range of lenders available to the customer',
                      component: '_table_col',
                    },
                    {
                      _uid: '94026fb0-db5e-461d-8f95-96485c72c91e',
                      value: 'localStorage',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'd8639b4e-6d8a-4860-ab2a-b7cbe44e1fe4',
                  body: [
                    {
                      _uid: 'dfc7abb2-4b35-4a4a-afe6-baac5e38e49e',
                      value: 'checkout-last-visited-stage',
                      component: '_table_col',
                    },
                    {
                      _uid: '08e01059-1874-4be9-b2f7-0d0bc83a1468',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '50b76588-490d-4451-9ebc-4adfd8d6c050',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '2551b517-5f79-4e84-b1c3-0a8f9d706450',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ff95756f-04b9-44a5-aaf2-d2ec95c96469',
                      value:
                        'This records the last stage of the checkout that a customer visited. This enables the website to return the customer to the correct stage of checkout if they navigate away partway through.',
                      component: '_table_col',
                    },
                    {
                      _uid: '128612a9-298a-4a00-ad0b-7081c14fca0c',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '9d505ce9-a92b-4cbc-b38a-bfcf71e2b45b',
                  body: [
                    {
                      _uid: 'f019f3fc-8f22-481c-90ef-719571389574',
                      value: '@@scroll',
                      component: '_table_col',
                    },
                    {
                      _uid: '13232a6e-134b-468a-b284-86161a3f5aa3',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '85900955-bc2b-4fa5-a05c-ea1c59c32c89',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '721a4455-ce80-4701-aa7b-401e64124d99',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '289a533b-d905-465f-8152-e5320d4b5412',
                      value:
                        'Records the scroll position on the previous page so that when a user navigates back they will be taken to their last scroll position on that page',
                      component: '_table_col',
                    },
                    {
                      _uid: '4fa51627-e1f3-451e-aafd-f9f7e77b1405',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'cd442aeb-07c6-4b7d-b6cb-1eb47675a155',
                  body: [
                    {
                      _uid: '649aec4e-af62-4e73-9824-809ce799fbbf',
                      value: 'keyval-store#keyval',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b61cad5d-ce62-42e8-87e8-4f770fdb9b23',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '6775b87f-e0ca-4f9f-b72d-6b19a2d14be8',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b44f2e6f-d694-4962-95d9-700b9d062e66',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '73ad6e06-7039-410e-b4d5-2919331b8113',
                      value:
                        'Records and stores the language preference of the user',
                      component: '_table_col',
                    },
                    {
                      _uid: '0dea5be7-0286-4803-b479-a9460d183ff3',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'bb2b491e-4d19-4e56-b4a8-d1baca5c849a',
                  body: [
                    {
                      _uid: 'b879cd0e-3314-43f3-aa3d-b819523fa0e9',
                      value: 'keyval-store#precached-details-models',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ab52cc9a-53f2-4d6d-b4ad-34e9c3fc79a3',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '1d0e8ef0-3c58-4f8a-8280-e8aace22f66d',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a0121466-e969-40aa-a99b-cb782ebb9424',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '6fab42e9-205a-410b-86bb-e57c66ec5b32',
                      value:
                        'Used by gatsby allow website to be used offline as well as online. In case of network connectivity issues',
                      component: '_table_col',
                    },
                    {
                      _uid: '7a5dbbe5-06cd-4b5b-bf74-22bbe15302a3',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '8637f6c2-844f-4cf0-888c-5eeb93c8f039',
                  body: [
                    {
                      _uid: '9b2bad18-630c-4fad-a42f-65e4e7c079da',
                      value: 'testing-item-storage',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b73ca816-1b90-42e1-b4bd-250bdc861d62',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '0d5d579d-e04d-47cc-bf2b-ea5ae802751c',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd3aada84-fb5a-44c8-b72b-11b6afb9d6a2',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '3130667a-6b62-40de-8bc8-7ffc20796683',
                      value:
                        'Gatsby testing if item storage works. Needed for performance of website services',
                      component: '_table_col',
                    },
                    {
                      _uid: 'dfe3d0db-9023-41f8-800e-fdfeeec4ba2c',
                      value: '1 second',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'ba7695cc-2bfa-40de-8c74-c80640a44f26',
                  body: [
                    {
                      _uid: '22c7c87a-9f0a-484c-81e6-046c9c6de31e',
                      value: 'oidc.',
                      component: '_table_col',
                    },
                    {
                      _uid: '7fbce8d5-0374-4357-b38e-48d5762e2321',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '9cde4242-dd84-47c0-bb4f-3f784d3d8d18',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '7d32f334-87d7-4c03-a0c2-007a67cedfa1',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '0ff75b71-0c7b-452b-8859-2f0fe69bf9a5',
                      value:
                        'Authentication cookie, used when connecting to a secure HTTPS server',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c734704d-5ce8-4693-8d5d-55864a26ed6d',
                      value: 'localStorage',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '62347791-1e2e-434a-b770-a142653cd364',
                  body: [
                    {
                      _uid: '3f9e7745-5c60-44dc-8d6d-264794a8b5af',
                      value: 'persist:partex',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f3faa1c4-63e0-46ca-8ac4-0a5a78b9e9e3',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: 'aa6bea1e-f5cf-4511-8400-05b94271b149',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'bf88e782-cec3-442b-a8ef-4a249039a7ab',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '565ad3c1-31b1-4567-9e67-9299f1a1ec33',
                      value:
                        'Used to persist part exchange valuations across the site.',
                      component: '_table_col',
                    },
                    {
                      _uid: '94e0a151-3647-487d-94f3-e3053cf51126',
                      value: 'localStorage',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'c9d805b9-1abd-4ee8-a596-60b661d75695',
                  body: [
                    {
                      _uid: '85bb998e-06e9-407a-a188-d71d8c566d18',
                      value: 'check-eligibility',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a4506e46-a394-4ae8-96c4-e3382f79ed0d',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '403d8374-30ef-435d-a68c-455d92be2dd1',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f5fbbd3e-98e2-4383-bb01-f84aa3b74b08',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '89de6bb9-2d12-4073-85ea-698cce091441',
                      value:
                        'Used to persist finance eligibility results across the site within the same session',
                      component: '_table_col',
                    },
                    {
                      _uid: '35a08d94-53d7-4cc2-bb8d-647612bc4057',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'd12f986e-c355-440d-b7aa-4c85f646b955',
                  body: [
                    {
                      _uid: 'e2fa715a-2f23-4e6b-8e7f-76d4a0a123a1',
                      value: 'free-text-search',
                      component: '_table_col',
                    },
                    {
                      _uid: '31e29fff-e9d7-4398-8473-426d6a661d0a',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '3f0a75a1-5872-4b75-bf27-3b18a7f487a2',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '643b669b-2ad6-4ff7-96fd-afa39374be63',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '293af38c-70b6-408b-9e62-d8bd1d9a98f7',
                      value:
                        'Records the customers previous searches so when they navigate back to search they can easily select them again.',
                      component: '_table_col',
                    },
                    {
                      _uid: '9f06863f-2270-41de-8918-95dbe7123beb',
                      value: 'localStorage',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '0949b85a-732e-474e-87c9-d2dc923abc10',
                  body: [
                    {
                      _uid: '90895053-33fe-4efd-8baf-c23e4b053ad3',
                      value: 'compare-bar',
                      component: '_table_col',
                    },
                    {
                      _uid: '4794d248-6c35-4771-a85e-026c6684d84e',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '39df73ab-164a-4d6e-bbb7-57e866a878ec',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'cb44902a-504e-414e-b729-f9c94ac1213e',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '52db65d4-ffe2-45b0-aca1-9f5a5db9e56f',
                      value:
                        'Records a customers compared cars so when they navigate back to a page with the compare bar they can still see their compared cars.',
                      component: '_table_col',
                    },
                    {
                      _uid: '60015872-d385-46b7-9110-15269edef56d',
                      value: 'localStorage',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '1ab8821d-aa79-466c-91ce-45bd174d2b93',
                  body: [
                    {
                      _uid: 'd3428830-8a13-4d89-8ef1-cfd6ddf28079',
                      value: 'help-me-choose',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ea5da76d-83dd-4989-aa4e-874f5c050f66',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '1893fc57-a677-491f-9e53-68f0e9fde7d4',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '8c1dc98f-493e-411e-90c9-d36efdc1661e',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '6f9b6489-39f2-4a91-a782-5d728a6ab8f9',
                      value:
                        "Records a customers selected 'Help Me Choose' answers so if they navigate back to the journey they don't have to fill them in again.",
                      component: '_table_col',
                    },
                    {
                      _uid: '370e7718-0ed3-4bd2-945e-eb56c161c478',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'fac5b048-ae63-4413-bedc-359e8109d584',
                  body: [
                    {
                      _uid: '35413547-fcd4-4a70-9c71-f675da32b79f',
                      value: 'awin',
                      component: '_table_col',
                    },
                    {
                      _uid: '300b5059-3907-4c72-b8cc-a919cb0933b5',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '619e342d-3cc0-4ff2-ab49-91241d2a6395',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '13852365-8643-48e9-b3ee-f0df291abc4a',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ad86556d-323d-48bf-99be-a521518cce8a',
                      value:
                        'Saves Awin specific tracking data, which will be used if a customer purchases a vehicle.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ce5d77a5-c4bd-4266-a058-8a8a3dfd16b4',
                      value: '30 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
              ],
              thead: [
                {
                  _uid: '351ba1f7-a9d0-4df7-a479-fc2156fc9345',
                  value: 'Cookie ID',
                  component: '_table_head',
                },
                {
                  _uid: 'b7e4f7ec-8c39-4a7f-8040-78388284173d',
                  value: 'Company Name',
                  component: '_table_head',
                },
                {
                  _uid: '66b0313e-0d36-49bf-a3ad-361433fef7f4',
                  value: 'Link',
                  component: '_table_head',
                },
                {
                  _uid: '7688191c-3af4-4cd1-9409-32c950d1d3be',
                  value: '1st Party or 3rd Party',
                  component: '_table_head',
                },
                {
                  _uid: '1a83fd49-6f8a-4525-9db2-aa600e1f901b',
                  value: 'Use',
                  component: '_table_head',
                },
                {
                  _uid: 'c8826d2f-a72b-4b1f-9de0-299001cfc103',
                  value: 'Lifespan',
                  component: '_table_head',
                },
              ],
              fieldtype: 'table',
            },
            heading: 'Strictly Necessary',
            component: 'TableSection',
            description: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'We use browser cookies that are necessary for the site to work as intended. For example, to store your website data collection preferences so we can honour them if you return to our site, to allow you to log in to your account, and to provide services you have requested, such as ensuring rewards/cashback sites can recognise a sale has occurred. You can disable these cookies in your browser settings but if you do the site may not work as intended.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            dontShowTableHeader: false,
          },
          {
            _uid: '9b6c02ab-41c0-4a92-bd14-5c1db376a68b',
            table: {
              tbody: [
                {
                  _uid: '30e7671f-2c2e-4094-9aa9-a154ced959db',
                  body: [
                    {
                      _uid: 'ee918695-71c1-4971-8960-014adca68319',
                      value: 'ajs_user_id',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e53420f8-6794-493f-9401-1909afc6449b',
                      value: 'Segment',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd7394783-b728-4f61-95e1-2c447a26696d',
                      value:
                        'https://privacy.microsoft.com/en-GB/privacystatement',
                      component: '_table_col',
                    },
                    {
                      _uid: '46a29b61-2967-4bbb-9c7d-37ff3f052fd8',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '5c0ae973-49a7-4f6c-a2fa-d130231df122',
                      value:
                        'Used by Segment to link anonymous ID with cinch userID',
                      component: '_table_col',
                    },
                    {
                      _uid: '2cfd3bc6-bcea-4667-ad82-f2b5e7b43b2f',
                      value: 'localStorage',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'c874a065-5b95-4bc9-9480-8acedde0acb4',
                  body: [
                    {
                      _uid: 'a332c6ed-5cfe-42ae-b172-536a5ded664a',
                      value: 'ajs_anonymous_id',
                      component: '_table_col',
                    },
                    {
                      _uid: '0aa3694f-8ecd-4d03-9aa4-db80721be01f',
                      value: 'Segment',
                      component: '_table_col',
                    },
                    {
                      _uid: '5d268d80-7f1d-4dba-99da-631d12f6f83a',
                      value:
                        'https://privacy.microsoft.com/en-GB/privacystatement',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c1abd8e3-14c0-4969-ab4d-9295e2f750d5',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '04db1147-720f-403c-92e5-78298e094707',
                      value:
                        'used by Segment to anonymously correlate user sessions',
                      component: '_table_col',
                    },
                    {
                      _uid: '3f057ee1-9a19-4962-8762-b937848673ec',
                      value: 'localStorage',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '013bad3d-45ef-4e63-90b8-b0f41b5b9b88',
                  body: [
                    {
                      _uid: 'd52325d1-efc7-459e-bdcb-f2264d8b195c',
                      value: 'ajs_group_id',
                      component: '_table_col',
                    },
                    {
                      _uid: '76c59908-39fc-47c9-b5ac-efc3000f5b7b',
                      value: 'Segment',
                      component: '_table_col',
                    },
                    {
                      _uid: '558b08b8-4d07-433f-bdb3-bf33c09a4591',
                      value:
                        'https://privacy.microsoft.com/en-GB/privacystatement',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e8770b7e-da49-4d47-85f0-c36558689e06',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a21e051c-c84b-49b8-b475-ec6a88aafead',
                      value: 'Segment group id',
                      component: '_table_col',
                    },
                    {
                      _uid: '3903db6f-521f-4fbb-bcd0-43131d4638bc',
                      value: 'localStorage',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '9706a7de-f7e7-492d-ab85-0bc8a1e83d65',
                  body: [
                    {
                      _uid: '411a81e1-cbd3-44b1-9893-6b5ce9228073',
                      value: 'ajs_user_traits',
                      component: '_table_col',
                    },
                    {
                      _uid: '9c7d7384-bdfb-4a59-b9df-000eaaea8148',
                      value: 'Segment',
                      component: '_table_col',
                    },
                    {
                      _uid: '2633623b-0c06-45bd-823a-0b6b80227542',
                      value:
                        'https://privacy.microsoft.com/en-GB/privacystatement',
                      component: '_table_col',
                    },
                    {
                      _uid: '334f86db-7094-4d14-a6a9-848c48c4fdf5',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd4ca5ea8-5793-430c-b362-7878c85a37c1',
                      value: 'Store Customer details (traits) for Segment',
                      component: '_table_col',
                    },
                    {
                      _uid: '706275bb-0699-4f54-9bc1-ad2985e191b6',
                      value: 'localStorage',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '5d4aa6d3-fb80-451b-88b5-aeb0c746e8f1',
                  body: [
                    {
                      _uid: '02d331d0-551a-4789-821a-99b7473e6796',
                      value: 'ajs%3Acookies',
                      component: '_table_col',
                    },
                    {
                      _uid: '748b3efc-d56b-49f3-bf70-ba6f16ce444a',
                      value: 'Segment',
                      component: '_table_col',
                    },
                    {
                      _uid: '7e245a6d-4437-4aa8-99c0-b5db34e2065e',
                      value:
                        'https://privacy.microsoft.com/en-GB/privacystatement',
                      component: '_table_col',
                    },
                    {
                      _uid: '239d36b0-c8ef-4ee9-b422-52c16eb91b1b',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '44e831f7-55cf-4324-a625-695f5ca5870b',
                      value: 'Used by Segment to test cookies',
                      component: '_table_col',
                    },
                    {
                      _uid: '184c4832-ea4d-451b-b40c-cba0fcab97f1',
                      value: '1 second',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '9c05f6d7-bc85-423a-aa57-2e2e41919795',
                  body: [
                    {
                      _uid: 'a083458f-f413-4c81-8828-e45029c90de9',
                      value: '__tld__',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fe4d0a7b-4fa2-46af-8641-05aa18a1f810',
                      value: 'Segment',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a6d23843-6464-4dc4-91b5-2c66603243a1',
                      value:
                        'https://privacy.microsoft.com/en-GB/privacystatement',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd3b2452e-65b7-45f5-85a6-b03bfa176827',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '2fdecd08-4704-4f83-a83c-171c7fcc45da',
                      value:
                        "Used to present relevant advertisement based on the visitor's preferences.",
                      component: '_table_col',
                    },
                    {
                      _uid: 'b1105c66-8223-41b1-8c35-92738f2e1050',
                      value: '1 second',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '82ccd6ee-a0ad-485d-b251-2455135f2f44',
                  body: [
                    {
                      _uid: 'f39eff32-d6d2-4e12-9656-f46e36e6190d',
                      value: 'cinch-recently-viewed-cars',
                      component: '_table_col',
                    },
                    {
                      _uid: '61c8a5ff-7048-4fef-8f28-190a473b2ae2',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '5c6d1645-c3ba-442b-b47c-c9ec9c9fde9d',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '663f9572-4966-4a18-8b39-25ce3f396e75',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '801e6add-a2f6-4ceb-a309-8fa80b4e0e63',
                      value: 'Stores the ids of the vehicles a user has seen.',
                      component: '_table_col',
                    },
                    {
                      _uid: '9dec0485-16e0-4384-9e10-dd0e847a2750',
                      value: '14 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'a834cb61-c247-472e-927d-809f8386f8d1',
                  body: [
                    {
                      _uid: '552f5214-01c0-46aa-9d52-05c0172648de',
                      value: 'usedCarsPreviousUrl',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f301da8b-a0fc-4801-84ab-bdf1de87cf77',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fd735c1c-57e6-4711-94ba-0d77067ed78b',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '3d78f1c8-e645-4d8f-a9a0-aaf840b71515',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '3abbc47e-53d2-4f34-8124-4db52d4e8c23',
                      value: 'Stores the users visited URL',
                      component: '_table_col',
                    },
                    {
                      _uid: '13220331-5ee5-4c69-9806-8cdca642d8f8',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
              ],
              thead: [
                {
                  _uid: '2e3acb98-a8e1-4587-84b8-8b2565078e8c',
                  value: 'Cookie ID',
                  component: '_table_head',
                },
                {
                  _uid: 'd652f249-78bf-4a80-a2ad-b0dd9febb0a6',
                  value: 'Company Name',
                  component: '_table_head',
                },
                {
                  _uid: '7fa57516-7302-4adb-b62f-009b984a2610',
                  value: 'Link',
                  component: '_table_head',
                },
                {
                  _uid: '171c57c3-e715-4f9a-a519-ba9bdcbccaf6',
                  value: '1st Party or 3rd Party',
                  component: '_table_head',
                },
                {
                  _uid: '3302061c-76db-44de-b0f4-5b99a1685a3a',
                  value: 'Use',
                  component: '_table_head',
                },
                {
                  _uid: '08878d87-f429-4f86-872e-cb8858cfb1a6',
                  value: 'Lifespan',
                  component: '_table_head',
                },
              ],
              fieldtype: 'table',
            },
            heading: 'Functional',
            component: 'TableSection',
            description: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'To monitor the performance of our site and to enhance your browsing experience. For example, these tools enable you to communicate with us via live chat.',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            dontShowTableHeader: true,
          },
          {
            _uid: '6b4ddf28-a0b3-4f17-b64c-786823405ecb',
            table: {
              tbody: [
                {
                  _uid: 'ca79b47a-d26b-43e8-9d61-db26f8cfd3d5',
                  body: [
                    {
                      _uid: '089543da-fc6c-46e7-a65a-d0f1e977fa27',
                      value: 'CONSENT',
                      component: '_table_col',
                    },
                    {
                      _uid: '4ba18456-1445-4dc8-8829-546d054009f3',
                      value: 'Google',
                      component: '_table_col',
                    },
                    {
                      _uid: '8eafca77-2784-4ad3-a7cb-b26edfe0f28d',
                      value:
                        'https://policies.google.com/technologies/partner-sites',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a605ac67-41f0-4c98-9ddc-71b5d2fbb2da',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b36d5e6b-b4ec-48fd-a9bb-bc16caeb0cfe',
                      value: 'Google cookie consent tracker',
                      component: '_table_col',
                    },
                    {
                      _uid: '405061f1-a0a1-4bb3-85a3-a9ec71b3161c',
                      value: '(2038-01-10)',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '8435ce0d-1ebd-40f9-83c8-07721db4243e',
                  body: [
                    {
                      _uid: 'd605ae6e-304a-4c5c-a385-b12b26c8f57f',
                      value: '1P_JAR',
                      component: '_table_col',
                    },
                    {
                      _uid: 'bfea3d63-bc28-4881-ad09-24e41c95f457',
                      value: 'Google',
                      component: '_table_col',
                    },
                    {
                      _uid: '02179d41-a018-43a4-aa07-24d8af528740',
                      value:
                        'https://policies.google.com/technologies/partner-sites',
                      component: '_table_col',
                    },
                    {
                      _uid: '3548f3fb-373d-4d0c-b5b6-c5654062575e',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '571f63b7-316a-4a3a-ab44-5488d85f317c',
                      value:
                        'set via embedded YouTube vids, register anonymous statistical data.',
                      component: '_table_col',
                    },
                    {
                      _uid: '630227bf-bd25-4d51-a6a1-11b4ef47d5ac',
                      value: '30 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '88cbf1c6-0994-43b5-82b7-3632a3934aee',
                  body: [
                    {
                      _uid: '3c038600-45a4-495e-b601-e8931aa56da9',
                      value: 'DV',
                      component: '_table_col',
                    },
                    {
                      _uid: '4e4dac14-3cc8-4b38-8874-1c0c041887b3',
                      value: 'Google',
                      component: '_table_col',
                    },
                    {
                      _uid: '98b2b040-79be-45c0-a043-6c3a602dc608',
                      value:
                        'https://policies.google.com/technologies/partner-sites',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e3323ffd-4cd3-4a1f-9d9a-03695ccea5ff',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd7da88b4-9548-417c-b62d-ba5aa7fa2ec7',
                      value:
                        'cookie used to collect website statistics and track conversions and google ads',
                      component: '_table_col',
                    },
                    {
                      _uid: '25ffc4de-f7c4-4286-9a30-45a2f840c215',
                      value: '0',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '578fe245-e534-4b7f-88b0-9ae438f55955',
                  body: [
                    {
                      _uid: 'ff6ad384-f60e-4010-a2cc-9401ab591f27',
                      value: 'NID',
                      component: '_table_col',
                    },
                    {
                      _uid: '07a91814-9148-4021-9b1f-29f165e699a1',
                      value: 'Google',
                      component: '_table_col',
                    },
                    {
                      _uid: '9e7a7a91-3ba5-49f6-8c26-02505cfe143d',
                      value:
                        'https://policies.google.com/technologies/partner-sites',
                      component: '_table_col',
                    },
                    {
                      _uid: '0ca04019-d227-49ec-86ce-afb906296092',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '6c000eab-dd2f-4991-833c-bce5b0752e9e',
                      value:
                        'cookie used to collect website statistics and track conversions and google ads',
                      component: '_table_col',
                    },
                    {
                      _uid: '0396e350-09e2-4d5a-af77-128aa111838d',
                      value: '6 months',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'a5acb994-de1d-4cd5-bfdf-33d079cfe735',
                  body: [
                    {
                      _uid: 'cc9ebd35-71a7-497f-955d-67f4ffd5ad11',
                      value: 'IDE',
                      component: '_table_col',
                    },
                    {
                      _uid: '8e946045-cc4b-4df3-8e84-e402ea8be287',
                      value: 'Google',
                      component: '_table_col',
                    },
                    {
                      _uid: '8c1761ab-72af-4a8f-a8d0-173971c44333',
                      value:
                        'https://policies.google.com/technologies/partner-sites',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b5eeb351-2560-4ec5-aed4-60f3b50d74e0',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '22a87ff9-3c6e-4890-904e-0fc85dce4f4d',
                      value:
                        'Third-party cookie set by Google’s DoubleClick platform, used for serving targeted advertisements that are relevant to you across the web',
                      component: '_table_col',
                    },
                    {
                      _uid: '2ab28341-4894-41b3-bfc4-ef5f1cbedea3',
                      value: '390 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'bb5e61c7-d244-4b1c-998c-9d4fbda5de7c',
                  body: [
                    {
                      _uid: '249b68b0-1c26-49b6-853a-b3831ad48283',
                      value: '_gcl_au',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b811634e-5ee3-4180-b700-d80190e6a7ea',
                      value: 'Google',
                      component: '_table_col',
                    },
                    {
                      _uid: '1f79820d-cb4b-4b7f-a859-4e84d0cd61e7',
                      value:
                        'https://policies.google.com/technologies/partner-sites',
                      component: '_table_col',
                    },
                    {
                      _uid: '0678ad5e-4d69-4344-ba7e-9d338b631fea',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '1fa4d409-edc2-46bc-a9f3-74259bab26c8',
                      value:
                        'Google AdSense for experimenting with advertisement efficiency',
                      component: '_table_col',
                    },
                    {
                      _uid: '4ab02c6f-81dc-4796-9a75-edc3e925be92',
                      value: '90 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '8ae2a2ed-9c2f-42d1-a520-93667e5bc6dc',
                  body: [
                    {
                      _uid: 'b9d3074d-10e1-475d-898e-1513e3470360',
                      value: '_gcl_aw',
                      component: '_table_col',
                    },
                    {
                      _uid: '12f26715-472e-46a4-9e4d-48688377c1cc',
                      value: 'Google',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd57fea58-d078-4ae3-8ec3-c36700484552',
                      value:
                        'https://policies.google.com/technologies/partner-sites',
                      component: '_table_col',
                    },
                    {
                      _uid: '608d6628-e03d-440f-bb87-fefd62d12c07',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '7115a994-4e26-480c-a4ac-0a2f7f634b80',
                      value:
                        'Used by the conversion linker for clck information',
                      component: '_table_col',
                    },
                    {
                      _uid: '542931c1-d366-4cf3-bb2d-34ef743f5d9d',
                      value: '90 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '2d1c1911-6247-442a-944a-7c55b0cf6e73',
                  body: [
                    {
                      _uid: '923ed7ce-4b56-41da-bbcd-a3cc5c2dedef',
                      value: '_gcl_dc',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c3dd43af-2631-4aec-aef7-225d94e4b198',
                      value: 'Google',
                      component: '_table_col',
                    },
                    {
                      _uid: '55b48a01-44d3-48ca-94b2-1e08599e26a4',
                      value:
                        'https://policies.google.com/technologies/partner-sites',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fc620074-837d-4268-b69b-8a6b3280b2dc',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '09566a27-23d1-4d9e-b092-a3e0b9c03401',
                      value:
                        'Used by the conversion linker for clck information',
                      component: '_table_col',
                    },
                    {
                      _uid: '5b91425b-8bc4-4992-8960-099dafec8720',
                      value: '90 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'b21bf8d3-b86f-40c0-990c-7ab3febec2e5',
                  body: [
                    {
                      _uid: '94088e29-11e1-4863-a713-2e002b7da10d',
                      value: '_fbc',
                      component: '_table_col',
                    },
                    {
                      _uid: '157eb2d8-250d-4fe9-add2-67a3fdae5dd5',
                      value: 'Facebook',
                      component: '_table_col',
                    },
                    {
                      _uid: 'be923104-a2e1-4e38-8ec6-2fcf13be6bfa',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '4d621e6b-25ad-4b11-a874-c79169395027',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '7d36bb28-4831-4474-807d-02e28e78e633',
                      value:
                        'The "_fbc" cookie is used by Facebook and stores information about your last visit to this website.',
                      component: '_table_col',
                    },
                    {
                      _uid: '4e1004b1-62a6-411a-8e0a-136e1b0a5c5c',
                      value: '2 years',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '71239e8b-80af-4cd0-8da7-08e4a6f049c2',
                  body: [
                    {
                      _uid: '157109a0-5092-4835-9bd0-f7fa9b66216c',
                      value: 'demdex',
                      component: '_table_col',
                    },
                    {
                      _uid: '7947cd1c-dea6-45d3-a1c7-410b9254a84c',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '4532b23e-e509-4467-9243-5216875130d7',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ca1b9699-1cc7-4c72-9113-cfc7575345bd',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c1e3aac1-783d-468d-a390-ae1720a51848',
                      value:
                        "Via a unique ID that is used for semantic content analysis, the user's navigation on the website is registered and linked to offline data from surveys and similar registrations to display targeted ads.",
                      component: '_table_col',
                    },
                    {
                      _uid: 'f4244f0c-b5b9-4c1d-bad8-f2c298a3de92',
                      value: '180 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '8a36801a-39b3-4501-8e0a-784f8be1ae02',
                  body: [
                    {
                      _uid: '1e2f8ce8-4abf-44ce-9108-f978c53e70f4',
                      value: 'dpm',
                      component: '_table_col',
                    },
                    {
                      _uid: '9351b572-5dbc-4d76-a6f9-72b975d77cbc',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '085ca61d-c75c-440c-bd62-047f8c703c8a',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'bf6916fb-9f27-46fd-a06d-8e992a085a25',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '50704c09-982d-499f-b941-2c621e9a6a78',
                      value:
                        "Via a unique ID that is used for semantic content analysis, the user's navigation on the website is registered and linked to offline data from surveys and similar registrations to display targeted ads.",
                      component: '_table_col',
                    },
                    {
                      _uid: '3d21eed9-bdde-4f26-92b7-69fa7278d0ab',
                      value: '180 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '2b16fc9d-8498-4d2a-a33c-ac80c3307e51',
                  body: [
                    {
                      _uid: '35c4fef8-65a2-4cad-b5a1-c8480937aecb',
                      value: 'ajs_anonymous_id',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fd3dde8a-e30b-47a9-a405-6d05b5afc797',
                      value: 'Segment',
                      component: '_table_col',
                    },
                    {
                      _uid: '8af99b3f-11c0-4718-bc2a-fd2f2a7a9ed5',
                      value:
                        'https://privacy.microsoft.com/en-GB/privacystatement',
                      component: '_table_col',
                    },
                    {
                      _uid: '394e2781-c427-4c18-a6e8-f4c13d23c06e',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '53389b84-40d4-47e5-b59b-c408c415882f',
                      value:
                        'used by Segment to anonymously correlate user sessions',
                      component: '_table_col',
                    },
                    {
                      _uid: '06d2c228-ef50-4065-8365-5e101ff30887',
                      value: 'localStorage',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '7fa8d369-da43-4077-b9d9-3fe9c1da7b3f',
                  body: [
                    {
                      _uid: '41203a34-6bce-4dbd-98e4-22ed1fb4023b',
                      value: 'APC',
                      component: '_table_col',
                    },
                    {
                      _uid: '83e812d9-6745-4828-a1b2-d00c1c228044',
                      value: 'doubleclick.net',
                      component: '_table_col',
                    },
                    {
                      _uid: 'eaa2b631-8fe4-4ba4-b1e8-10ef9ae3646f',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'cac4a153-5233-4208-bb0a-007b68b75abe',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a7a37c17-7800-4d0a-a32d-babad43c1b3f',
                      value:
                        'Google cookie used for advertising and security purposes',
                      component: '_table_col',
                    },
                    {
                      _uid: '70da3149-169d-4f93-be87-f108b47c559f',
                      value: '6 months',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'e2cf4d5d-74f8-466f-96c7-127655cb74c5',
                  body: [
                    {
                      _uid: 'f931eaf9-3090-42e3-a30c-c983f4e3a85f',
                      value: 'ar_debug',
                      component: '_table_col',
                    },
                    {
                      _uid: '4d81525f-d3c8-4936-a5ef-6dd4b30ab3c0',
                      value: 'doubleclick.net',
                      component: '_table_col',
                    },
                    {
                      _uid: '65313222-aec4-4266-9465-42881a139218',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e62983b9-9e04-45f6-8ebe-c37cecfe3a3e',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '3fb85727-464b-474f-9b3e-4bdaa1daced6',
                      value:
                        'DoubleClick sets this cookie to debug and troubleshoot the ads served by DoubleClick.',
                      component: '_table_col',
                    },
                    {
                      _uid: '8c116378-8192-4440-b180-0229268c2421',
                      value: '90 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'ab272e24-d6e4-415c-baa0-f0e638e39caf',
                  body: [
                    {
                      _uid: '1294052b-c1b6-4fa5-a9ce-93cbcf9b42f2',
                      value: 'AdsWizz OAID, sessionId ',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ef13f4ce-7676-4a4a-a5ab-11453c46611f',
                      value: 'AdWizz (Octave) ',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b740fd9a-1bd7-487e-b8c2-cc6b77f22f10',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'bb6ae288-c540-4d8b-9e11-4b783ac03d19',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '7193c64d-6810-4b25-9e10-c4bd098b3ab9',
                      value: 'Advertisement\n',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fb860b4f-fed6-48d2-a1c2-cacf8eaec6d1',
                      value: '90 days ',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '55bc9655-a368-49d6-a5ce-b02fed9068f6',
                  body: [
                    {
                      _uid: 'df9b6ac5-5e5e-4e4f-8f2e-1dead4036b0e',
                      value: ' __adal_se',
                      component: '_table_col',
                    },
                    {
                      _uid: '4ce01a0f-2cac-4406-9d93-f9f654e748cd',
                      value: 'Adalyser (OneSoon)',
                      component: '_table_col',
                    },
                    {
                      _uid: '91ec6edb-54b8-499b-98b0-4d8d124fee77',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd72ce207-0bf0-433a-8afa-5a8167df9bc4',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '301dc3ce-0752-405b-8bfa-1e338f27c0d6',
                      value: 'Advertisement',
                      component: '_table_col',
                    },
                    {
                      _uid: 'bc9ca30e-f986-46f1-a7f4-ab119e16dafa',
                      value: '30 minutes',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '651ba5a4-96ef-4cb2-8d9f-d6319a03ed5e',
                  body: [
                    {
                      _uid: '48300fa1-f5cd-4c44-baa9-a5fdd7e4b701',
                      value: '__adal_ca',
                      component: '_table_col',
                    },
                    {
                      _uid: '195c4a0a-b181-4f18-aa6b-0e6960f800bb',
                      value: 'Adalyser (OneSoon)',
                      component: '_table_col',
                    },
                    {
                      _uid: '7545d42b-2e1a-4fc3-a21d-e55cd7f18200',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'beecdfc3-9064-4457-b165-8f1007bb6323',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c6856db9-b41f-4de8-8613-f81690551ca5',
                      value: 'Advertisement',
                      component: '_table_col',
                    },
                    {
                      _uid: '5c0d56df-4b18-4fa2-9866-f4af7f78d6fb',
                      value: '6 months',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'b401051d-fa29-4360-8f98-0bf5d1894ae2',
                  body: [
                    {
                      _uid: 'b240d26e-1697-4a82-85ab-ce28e436dd30',
                      value: '__adal_id',
                      component: '_table_col',
                    },
                    {
                      _uid: 'edb43c20-0fb5-46b3-a8e3-b856038f8ca9',
                      value: 'Adalyser (OneSoon)',
                      component: '_table_col',
                    },
                    {
                      _uid: '734f319a-a515-49be-aae9-9a0a02cb0551',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '54185060-3cc9-4c62-bb15-0f760f865e6b',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '886968e3-aaf1-45e2-989a-b9c527c8c019',
                      value: 'Advertisement',
                      component: '_table_col',
                    },
                    {
                      _uid: '7d95175e-f441-4353-9fb6-7eceaaac7671',
                      value: '2 years',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '91ad05ac-0874-4095-9e60-a841e9b51b10',
                  body: [
                    {
                      _uid: '4ec9fa29-7f3d-4d57-a329-b1b9f6a35e66',
                      value: '__adal_cw',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ae0b35c8-82bf-437f-a264-6657208fbf99',
                      value: 'Adalyser (OneSoon)',
                      component: '_table_col',
                    },
                    {
                      _uid: '08f3a915-5e44-4bc7-871a-f715da8b6525',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '77c50f17-6432-4b52-a527-0daa8ce59dd7',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '8c11965f-482f-4cc0-a98a-d6bed35c1761',
                      value: 'Advertisement',
                      component: '_table_col',
                    },
                    {
                      _uid: '8a2cf756-3d78-4c31-883f-9c71f3c842ff',
                      value: '7 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '5847fe79-46a1-48c1-a0dd-f95e9908337f',
                  body: [
                    {
                      _uid: '8d389856-fa92-4ca9-a68a-1188898b3859',
                      value: 'crm_enrichment:email',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a3ff1a08-c039-46bf-8982-09597698594b',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '7c856462-d140-49dc-8254-6d3c5a1c54d5',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '42ab95be-3a93-4e76-a9d5-d56372eaa323',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b8eb91e6-2ab8-4f5c-a1dd-b1b81436ba99',
                      value:
                        'Uses email entered into the Part Exchange form or Search Alerts form to help match Segment profiles to Customer.io profiles. ',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ffebebc7-69db-4e01-9572-6008c4804b38',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '945017f5-f178-4654-beb3-1d216a652a3d',
                  body: [
                    {
                      _uid: '771bfe35-9751-48a5-8069-7be72157e85b',
                      value: '__podscribe_did',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd45fcbce-303a-4d1e-bad0-40921638bdc3',
                      value: 'Podscribe (Podible Inc.)',
                      component: '_table_col',
                    },
                    {
                      _uid: '7c7e94c3-8bf5-4e60-a257-bad359667a48',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ed800fd6-6e12-40ed-ba97-7ce475ea8b6f',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '9c959da4-504d-430f-8a7a-eb8d994cccfa',
                      value:
                        'Used by Podscribe to measure the impact of audio campaigns on listeners.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e3aeb4c4-a4e2-4015-90ad-e5edb74860cb',
                      value: '90 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '0492ef77-9800-4b14-8589-c923a7f2a115',
                  body: [
                    {
                      _uid: '5c167d6f-d995-48a0-8415-4b83a3d67a9d',
                      value: '__podscribe_cinch_landing_url',
                      component: '_table_col',
                    },
                    {
                      _uid: '09c17002-83de-4c0d-a0c3-07900a02e3ec',
                      value: 'Podscribe (Podible Inc.)',
                      component: '_table_col',
                    },
                    {
                      _uid: '098e60e1-69ee-43a6-8427-f0374cbc32f4',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e309a759-849a-4308-8732-28374b681c27',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '6210aa58-5f57-43aa-a315-ddd955788c58',
                      value:
                        'Used by Podscribe to store the landing page URL of site visitors when measuring the impact of audio campaigns.',
                      component: '_table_col',
                    },
                    {
                      _uid: '603774b6-1c41-4c8e-9a46-ee8860c38cfd',
                      value: '90 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '355de76e-1911-43ac-891a-a35c10aa7b8d',
                  body: [
                    {
                      _uid: '2c1cc593-ed2b-43d4-9a4c-e760e1fe1651',
                      value: '__podscribe_cinch_referrer ',
                      component: '_table_col',
                    },
                    {
                      _uid: '489725ea-4f52-448a-8485-70f2672f286d',
                      value: 'Podscribe (Podible Inc.)',
                      component: '_table_col',
                    },
                    {
                      _uid: '364b18a6-62e9-4e73-9b58-f5a81e64d72c',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '2b6cb6bf-1289-4955-9ae0-2ab25d7a09fa',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '571cae58-2dd8-43ec-917c-f5af00d3361c',
                      value:
                        'Used by Podscribe to store the referrer URL of site visitors whean measuring impact of audio campaigns.',
                      component: '_table_col',
                    },
                    {
                      _uid: '8cd6b89d-c153-497d-b720-94a5130812dd',
                      value: '90 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
              ],
              thead: [
                {
                  _uid: '7649eb0e-5791-4819-8365-266cf4234743',
                  value: 'Cookie ID',
                  component: '_table_head',
                },
                {
                  _uid: '3485ae25-405b-4f5c-a943-dccca6a4d550',
                  value: 'Company Name',
                  component: '_table_head',
                },
                {
                  _uid: '67aada79-5ad6-4a9c-819a-ce54cfe7f0a3',
                  value: 'Link',
                  component: '_table_head',
                },
                {
                  _uid: 'b93c125d-64e5-45b9-9b3d-52768cc0147f',
                  value: '1st Party or 3rd Party',
                  component: '_table_head',
                },
                {
                  _uid: '7dd1b714-c3b6-4d26-bfe4-2053c6311524',
                  value: 'Use',
                  component: '_table_head',
                },
                {
                  _uid: 'db699f4b-4cd0-43dc-be8d-930d5540c98f',
                  value: 'Lifespan',
                  component: '_table_head',
                },
              ],
              fieldtype: 'table',
            },
            heading: 'Advertisement',
            component: 'TableSection',
            description: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'To personalise and measure the effectiveness of advertising on our site and other websites. For example, we may serve you a personalised ad based on the pages you visit on our site.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Accepting advertising means your data (including anonymous IDs or other encrypted identifiers) may be shared with the third parties specified below. We also use technologies such as web beacons and tracking pixels to allow this to happen.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            dontShowTableHeader: true,
          },
          {
            _uid: '9dc7638e-c92c-4581-ba89-be7ebf82dadd',
            table: {
              tbody: [
                {
                  _uid: 'c9a2e796-9a55-44e1-b61f-e825afb653b8',
                  body: [
                    {
                      _uid: 'bf2ca407-967d-4c76-a6d5-110f7ef4ed39',
                      value: 'ad-id',
                      component: '_table_col',
                    },
                    {
                      _uid: '8adb6c98-933d-416c-a36f-c16310fa4e6c',
                      value: 'Amazon',
                      component: '_table_col',
                    },
                    {
                      _uid: '5b61a3b2-22ce-4f11-8439-5d5bedf86505',
                      value:
                        'https://www.amazon.co.uk/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ',
                      component: '_table_col',
                    },
                    {
                      _uid: '6554e90c-8ea2-4fba-94a8-670ab036f2b7',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '667f2cee-936b-440a-ba72-bb32a6d18208',
                      value:
                        'Used by Amazon Advertising to record user actions and target website content based on ad clicks on a different website',
                      component: '_table_col',
                    },
                    {
                      _uid: '1d7940f5-d3fe-448c-897d-7e68f43002e9',
                      value: '13months',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'c97c32d0-1ce0-4795-a1f2-127f687bde46',
                  body: [
                    {
                      _uid: 'a068f9d2-22a7-4d6a-a611-14cd6ef42c7e',
                      value: 'ad-privacy',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ac9e43af-983d-448e-970a-dd2c261e6498',
                      value: 'Amazon',
                      component: '_table_col',
                    },
                    {
                      _uid: '710989dc-0ef3-44ba-a1ca-2f8e8687a120',
                      value:
                        'https://www.amazon.co.uk/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c94e4164-28fc-4740-95b9-f6433a4e2a74',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '8a7ce276-fe47-4a8b-9d01-8555d03f48f6',
                      value:
                        'The cookie is used by Amazon Advertising to manage opt-outs',
                      component: '_table_col',
                    },
                    {
                      _uid: '8dc3e80d-56ff-45fe-b8c2-e1c61f66dbeb',
                      value: '5 years',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '490c0aa5-a8cf-4349-900e-845a6dc60f83',
                  body: [
                    {
                      _uid: 'dc89094e-ff37-47f9-8e69-731076077fd6',
                      value: 'AMZNTOKEN',
                      component: '_table_col',
                    },
                    {
                      _uid: 'dbaed037-530c-4320-a6dc-09ecf9a2476d',
                      value: 'Amazon',
                      component: '_table_col',
                    },
                    {
                      _uid: '03079905-785f-4f55-b6c9-dd9410d1f5bd',
                      value:
                        'https://www.amazon.co.uk/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ',
                      component: '_table_col',
                    },
                    {
                      _uid: '19cdc21c-cb9b-460d-bbe0-f868d316fe93',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '5e1acac6-d371-496a-855b-b17a0e34f6ee',
                      value:
                        'When using the hashed PII implementation to pass email, there will be a new cookie called AMZNTOKEN set',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e0d6c177-99a3-4f35-adbc-b79f25f312f7',
                      value: '3 hour TTL maximum 7 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '93ab9c35-209a-4399-84d7-68647603d33a',
                  body: [
                    {
                      _uid: '7f1b7603-4db4-4a06-bbc7-720fe4c8b857',
                      value: 'AMCV_E5F2C8A15481C0E20A4C98BC%40AdobeOrg',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ae3bde75-313a-483b-bd35-e6639bdb8499',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '0857f824-4e9f-4305-91e1-0b60bb48f9fc',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '7e29ee1d-ec35-4685-b368-1eab74a32cab',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '8f1e1a6d-8713-46d4-9b9e-48ec3f2bb9dc',
                      value:
                        'Pattern type cookie name associated with Adobe Marketing Cloud. It stores a unique visitor identifier.',
                      component: '_table_col',
                    },
                    {
                      _uid: '465ac2c0-9d57-4b1c-9dd3-dd0905dafdcf',
                      value: '2 years',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '8c58ab97-3132-4573-8826-e876b96d2c75',
                  body: [
                    {
                      _uid: 'b466b6e5-a01f-4b30-a00c-5032498c30dc',
                      value: 'mbox',
                      component: '_table_col',
                    },
                    {
                      _uid: '891a15f0-7a2a-4754-85f6-2f037ba82d21',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '446f45a8-e124-498e-8b91-d9a09900121d',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '5f170c11-3915-4070-badd-a40c1497e6e6',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '2d0c2d3d-865a-451f-86d5-198cde958c9d',
                      value:
                        'Test to see which content is more relevant to visitors.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'cb3b3482-1600-4ad1-a483-031a1ee23243',
                      value: '2 years',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'c12c0b6f-dc72-44f9-a871-31810adaa0bd',
                  body: [
                    {
                      _uid: '38195eca-68e5-45a8-970f-1a890b7fd2fb',
                      value: 'mboxEdgeCluster',
                      component: '_table_col',
                    },
                    {
                      _uid: 'be7abe56-9fd8-457e-93dd-01a63d3b2f75',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd4c8d917-e20a-4806-b372-a89916c54f79',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd81024d0-b4b6-4e17-bc14-cc65b75889a4',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c86da469-36a4-4076-b38a-08b0c1837209',
                      value: 'Adobe Target cookie',
                      component: '_table_col',
                    },
                    {
                      _uid: '0d160aab-5b8f-4888-b135-711d64619965',
                      value: '30 minutes',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '0347510c-7307-4faa-9726-78c4eea3cc71',
                  body: [
                    {
                      _uid: 'b3772c51-2db6-48b3-b32b-1084bf666b5d',
                      value: 'check',
                      component: '_table_col',
                    },
                    {
                      _uid: 'acd8ea13-022b-44b6-9ecc-c2971ac6def3',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c997bb66-e2b1-4fdd-8450-79e2600ec3f1',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a6eb496d-7446-43e6-ae66-9114d1611700',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '8d330c0a-98f0-4b9c-ba05-261f679d9f95',
                      value: 'Used to test that cookies work',
                      component: '_table_col',
                    },
                    {
                      _uid: '59051805-ab37-469a-b74e-90f1229826b8',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '86ab6bb3-faf0-403f-95b1-505925905f6f',
                  body: [
                    {
                      _uid: '863ed3ab-1254-4aa4-9991-b0b7b904ebdb',
                      value: 'AMCVS_E5F2C8A15481C0E20A4C98BC%40AdobeOrg',
                      component: '_table_col',
                    },
                    {
                      _uid: '2f60ac13-ae9b-4b90-aa3a-fd1b633bddbe',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b93068ad-3c61-44d6-a926-5736f5a9cb4b',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b80b3e89-0955-4285-a421-6ab77dd74516',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '39018f62-3097-40a0-8d83-27b400341cc1',
                      value:
                        'Pattern type cookie name associated with Adobe Marketing Cloud. It stores a unique visitor identifier.',
                      component: '_table_col',
                    },
                    {
                      _uid: '885d2afb-1a4f-49db-a152-693679a67e3e',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'a0ff5072-a827-46ab-94de-026b6381ed47',
                  body: [
                    {
                      _uid: 'e459a752-37ca-4b18-87b8-f0884dd98052',
                      value: 's_getNewRepeat',
                      component: '_table_col',
                    },
                    {
                      _uid: '013540d5-217b-4dd2-bf95-afeb4cbdb715',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '274f3eac-6dd2-4b50-9275-9f255a0219ab',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '5e0ad6dd-e69b-487f-9277-166f7e62f29f',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '43a4b939-c10f-465b-af04-5e16293460dc',
                      value:
                        'Determine whether a visitor to the site is a new visitor or a repeat visitor within a desired number of days',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f6dececf-d957-440b-b0cb-44ebbd0532f4',
                      value: '30 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '61f55b34-80a8-41b8-a777-ffb70096ac7f',
                  body: [
                    {
                      _uid: 'e8558d4a-b414-4dce-9777-e64a625fc59f',
                      value: 's_invisit',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fae4c481-f6d0-452c-8ea1-4bc1670812fe',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '8689cf51-8883-4dbb-9ee9-1a5db776e821',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ba79f04f-7134-475c-8c12-5eef1aef08c7',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '7910621b-4faa-447d-b1ae-6855ce9627f4',
                      value:
                        'Determines whether the user is visiting the page for the first time',
                      component: '_table_col',
                    },
                    {
                      _uid: '10f7b30f-719e-4f25-9556-e29af99b6dd1',
                      value: '30 minutes',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'bd090e68-0557-430d-9f89-5bb7afb832c4',
                  body: [
                    {
                      _uid: '0966aa78-fd10-4ef7-92d8-ad84532d3578',
                      value: 'at_check',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f5822c11-7535-4c36-b832-9ec50933ce1c',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '038ac1ce-815a-4eea-9527-1a2e7c597b22',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '6162b27e-4adf-4561-aa11-815095815c65',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a4deebe2-2852-4235-83fa-0dc9d95abc68',
                      value:
                        'Determines if the visitor supports cookies or not.',
                      component: '_table_col',
                    },
                    {
                      _uid: '3577085b-fb3a-4144-946a-f37cda72e8a8',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '65af2843-778e-48eb-90ef-4a89cbd29260',
                  body: [
                    {
                      _uid: '47e43f9d-c640-4445-8cbc-f104f8ff6727',
                      value: 's_cc',
                      component: '_table_col',
                    },
                    {
                      _uid: '70ec9a69-82ff-4356-affd-22adaf0de344',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '2cf2312b-dbdc-498e-a5d8-5f5375e158cd',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '4ee4dc43-c170-4757-a09e-8116db2bee82',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '86089c3a-70ed-408b-bbbe-4b58bdfdde22',
                      value:
                        'This cookie is set and read by the JavaScript code to determine if cookies are enabled (set to “True”).',
                      component: '_table_col',
                    },
                    {
                      _uid: 'db0bd7d5-18d6-4c30-8fdb-2f6c3587e3ef',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '9b6b1590-32b9-4401-a514-ae933686a4a9',
                  body: [
                    {
                      _uid: '9ff6a06b-1070-4854-87da-6c0809847183',
                      value: 's_sq',
                      component: '_table_col',
                    },
                    {
                      _uid: '84c8bec7-99d7-4f06-8012-24412a1761d4',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a5030c5e-0d61-4d6f-a389-0415fa65acd9',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '72d186a1-0959-4193-b0e8-dac90ec5e05f',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e97e729a-9b98-4e11-ad5a-50ffe72f1a2e',
                      value:
                        'This cookie is set and read by the JavaScript code when the SelectMap functionality or the Activity Map functionality are enabled; it contains information about the previous link that was selected on by the user.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f42076ac-1e6f-4ca5-beb9-5a1c2ba36db7',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'bae055aa-b0e6-4d23-867c-ee67b474928c',
                  body: [
                    {
                      _uid: 'cf55b2d0-67c3-4851-a040-3dfa454da056',
                      value: 'Muid',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ccffa408-4145-444f-8599-1a5ebeb5d06f',
                      value: 'Microsoft',
                      component: '_table_col',
                    },
                    {
                      _uid: '49243ec6-268e-471c-aa8e-dadd752033ed',
                      value:
                        'https://privacy.microsoft.com/en-GB/privacystatement',
                      component: '_table_col',
                    },
                    {
                      _uid: '7fc09ffc-baff-43c5-bbed-0a1f48e9621a',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'db53541f-46da-4330-bac7-ae3ccae0cb37',
                      value:
                        'Set by Microsoft as a unique user ID. Enables user tracking by synchronising the ID across many Microsoft domains.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f468dd6d-f8bc-4111-895a-7ef5c6ea0fe7',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'cd67a6dc-426b-4bbf-8e92-8a3913cffb32',
                  body: [
                    {
                      _uid: '25830347-fa0c-49fc-befb-8b2493ce9f5b',
                      value: '_clck',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fb410912-f32a-456e-a653-2ea78a15c132',
                      value: 'Microsoft Clarity',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd914d8f7-9460-4eb3-9a5a-80c8646b2593',
                      value:
                        'https://learn.microsoft.com/en-us/clarity/cookie-list',
                      component: '_table_col',
                    },
                    {
                      _uid: '639188da-56d8-455a-81fe-b113d0d819e1',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd45c34d2-9e0c-46b1-97df-856b5f960e6c',
                      value:
                        'Persists the Clarity User ID and preferences, unique to that site, on the browser. This ensures that behaviour in subsequent visits to the same site will be attributed to the same user ID.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'dc941f33-983c-48f5-8667-cfe234d93312',
                      value: '1 year',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '792d37ef-a2d7-4256-b33f-5e9dc793d955',
                  body: [
                    {
                      _uid: 'a9cd2f6c-a793-4d1e-b433-48dca17f7c63',
                      value: '_clsk',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c65f5688-1aae-428a-beaa-e744f21e5770',
                      value: 'Microsoft Clarity',
                      component: '_table_col',
                    },
                    {
                      _uid: '74075e04-bfdf-4a85-b903-9763084ce2e3',
                      value:
                        'https://learn.microsoft.com/en-us/clarity/cookie-list',
                      component: '_table_col',
                    },
                    {
                      _uid: '3efb0f36-f56b-4d10-8aeb-95721bc9c484',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '6ea272d9-9c16-4458-9f54-b9957f84354c',
                      value:
                        'Connects multiple page views by a user into a single Clarity session recording',
                      component: '_table_col',
                    },
                    {
                      _uid: '70578405-f214-45d4-9ded-8c16b957e5e0',
                      value: '1 day',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '57d86e33-eebf-49d4-b66c-90fa91008ba7',
                  body: [
                    {
                      _uid: '90710e2c-249c-41d7-99ad-abb7b240826f',
                      value: 'ANONCHK',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c8bf3f7e-7cca-4cb7-86c8-b87734ad6b22',
                      value: 'Microsoft Clarity',
                      component: '_table_col',
                    },
                    {
                      _uid: '1f5626e2-91c1-429a-9484-82bf73d93652',
                      value:
                        'https://learn.microsoft.com/en-us/clarity/cookie-list',
                      component: '_table_col',
                    },
                    {
                      _uid: '3ede6da4-15c5-45b7-8e35-32ce0400481d',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '50ca3ae3-cc89-4a97-96bf-e6f930091730',
                      value:
                        "Indicates whether MUID is transferred to ANID, a cookie used for advertising. Clarity doesn't use ANID and so this is always set to 0.",
                      component: '_table_col',
                    },
                    {
                      _uid: 'b8e81e4c-3c6a-48c3-a994-2e23cb4a3854',
                      value: '10 minutes',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '66e57c90-ec0c-4065-acce-1ef4e84acff8',
                  body: [
                    {
                      _uid: '2bc88521-0ddb-4dda-97b7-5c1ad78578d7',
                      value: 'SM',
                      component: '_table_col',
                    },
                    {
                      _uid: '6adf6585-56b6-40b6-949a-a6195cb4b18a',
                      value: 'Microsoft Clarity',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fefda779-1b76-420f-9660-4a2d5d6a902c',
                      value:
                        'https://learn.microsoft.com/en-us/clarity/cookie-list',
                      component: '_table_col',
                    },
                    {
                      _uid: '80470dde-f2e9-455f-bc2b-93186d6e9c43',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '40049f52-1ee5-4eee-a0a7-fb5280888890',
                      value:
                        'Used in synchronizing the MUID across Microsoft domains.',
                      component: '_table_col',
                    },
                    {
                      _uid: '0f0d553f-05ae-4275-a7c8-b180215649b3',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'c7f26645-421a-46fe-af98-c27e682c20f9',
                  body: [
                    {
                      _uid: 'db9c53ad-dca4-48e1-a23c-79ffb1d1f8e4',
                      value: 'CLID',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c0972b1b-747f-4ee4-a820-98f8c8b26a90',
                      value: 'Microsoft Clarity',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ab85f2c9-9d7c-4bd3-926f-d87f53caf9e5',
                      value:
                        'https://learn.microsoft.com/en-us/clarity/cookie-list\n\n',
                      component: '_table_col',
                    },
                    {
                      _uid: '9f3b2f08-5f74-4667-8709-816f082957eb',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '607232bd-8522-4e3f-b109-48c102bbbf3b',
                      value:
                        'Identifies the first-time Clarity saw this user on any site using Clarity.',
                      component: '_table_col',
                    },
                    {
                      _uid: '0b51d748-92a2-4410-8cec-652a7030a4bd',
                      value: '1 year',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '0931a640-0f03-4150-bfad-c8a5345ecf6e',
                  body: [
                    {
                      _uid: 'bab0e0c6-0dac-4c01-8a04-c5d50f157b0c',
                      value: 'Everest_g_v2',
                      component: '_table_col',
                    },
                    {
                      _uid: '8c780529-987c-49b8-9793-7dc7d76de12f',
                      value: 'Everesttech',
                      component: '_table_col',
                    },
                    {
                      _uid: '3ba5bc85-1cfb-4623-85c8-43d8c58fb3bf',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ef13e619-12f0-41aa-9225-95197605a820',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '084ee3bb-a48f-4d60-89d6-308a9b0a3b11',
                      value:
                        'Used for targeted ads and to document efficacy of each individual ad .',
                      component: '_table_col',
                    },
                    {
                      _uid: '88f059ff-d74b-45fa-ade2-b1f1c44e1f5e',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '701b4546-bd19-4cbb-9c1c-cfdc8f326de7',
                  body: [
                    {
                      _uid: '13ae7f77-8b53-4afa-af20-c27db99b25d9',
                      value: '_fbp',
                      component: '_table_col',
                    },
                    {
                      _uid: '9c305219-23b1-4e2f-be89-67cbfbe984d6',
                      value: 'Facebook',
                      component: '_table_col',
                    },
                    {
                      _uid: '10a665e1-f470-4af1-952b-4dd7a3d18543',
                      value:
                        'https://www.facebook.com/legal/EU_data_transfer_addendum',
                      component: '_table_col',
                    },
                    {
                      _uid: '6165df0f-ba27-4eca-aa18-144efaee7335',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '07c914c8-1ed2-4ff6-81a2-557208843033',
                      value:
                        'Used by facebook to track visits across the website. Generated in the following format:  version: fb subdomainIndex: Indicates which domain of facebook the cookie is set on creationTime: Unix timestamp for when the cookie was created and saved randomNumber: ensures each cookie is unique',
                      component: '_table_col',
                    },
                    {
                      _uid: '2b283f22-ead0-4376-8bed-de9c33d636af',
                      value: '90 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '0e551631-40f6-48b7-af59-d4160c7bea18',
                  body: [
                    {
                      _uid: 'b6e399a4-9a32-433c-bbe4-c03b9ecb451d',
                      value:
                        'com.adobe.reactor.core.visitorTracking.cookiesMigrated',
                      component: '_table_col',
                    },
                    {
                      _uid: '19967fcd-a627-4f13-bfeb-b6d47fb78675',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '3957d5e4-a877-4441-86b8-453db977b31d',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c1ae2633-15e8-4459-b8eb-15ba018ba720',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '71f53ac4-2c1c-4f23-99ad-c2d1554dfa66',
                      value:
                        'Used in context with the cache-function on the website, facilitating data transfer between Adobe DTM onto Adobe Launch.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd860f94f-d4d6-4ba6-b8ae-959d29c5c3ef',
                      value: 'localStorage',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'ff6da1f8-9020-4541-a5a7-9a27e4669ce9',
                  body: [
                    {
                      _uid: 'b3ec141a-15d0-4204-8383-eb43cb8eea0d',
                      value: 'com.adobe.reactor.dataElementCookiesMigrated',
                      component: '_table_col',
                    },
                    {
                      _uid: '083374b2-bf7e-4c16-b22c-e38c0236b46f',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ca373380-b998-441e-ab37-5974178fc5ca',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'aad0cd35-d3ad-422d-8fe8-9dfa3ea52691',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '2808a0ce-6def-4e21-8ef3-374fdb00ef4e',
                      value:
                        'Used in context with the cache-function on the website, facilitating data transfer between Adobe DTM onto Adobe Launch.',
                      component: '_table_col',
                    },
                    {
                      _uid: '3a96cf0b-617b-4ffd-a99a-1409a802063a',
                      value: 'localStorage',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '6848cee8-2b34-422d-8621-e4cc447a4c66',
                  body: [
                    {
                      _uid: '19d46557-f21d-4b28-a302-4458917d9a94',
                      value:
                        'com.adobe.reactor.core.visitorTracking.landingPage',
                      component: '_table_col',
                    },
                    {
                      _uid: '99472649-b380-4d85-9cf0-83715273d5c5',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '9319de5b-894d-4d9f-b02d-0be13b005611',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b67c2637-4466-44aa-9251-e5b3c3096600',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '7a3acce6-f228-4296-9d9d-64248a1b9202',
                      value:
                        "Stores visitors' navigation by registering landing pages - This allows the website to present relevant products and/or measure their advertisement efficiency on other websites.",
                      component: '_table_col',
                    },
                    {
                      _uid: 'e59bbf3e-27bc-4d5f-9a00-520db9a0f303',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'de6321d5-94af-4741-b575-2acdca7a8b6e',
                  body: [
                    {
                      _uid: 'e6c0cdab-3114-497f-ae0e-dd330d54db92',
                      value:
                        'com.adobe.reactor.core.visitorTracking.landingTime',
                      component: '_table_col',
                    },
                    {
                      _uid: '5331b32b-b7f9-4af7-abb2-b2171dce0040',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e21442da-9fc9-4fc9-afda-ba239416e005',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '6b860f70-e4c8-4d68-b34d-fdc02c11aea4',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'be9458eb-ad14-4e80-ada5-0dcd4447b764',
                      value:
                        'Sets a timestamp for when the visitor entered the website. This is used for analytical purposes on the web site.',
                      component: '_table_col',
                    },
                    {
                      _uid: '3d51eaf5-0252-41d3-a0cf-47b2ee91ba20',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '7d325e81-7eb3-42a4-acb7-9af56c2f939a',
                  body: [
                    {
                      _uid: 'ca6882f8-689c-4ce3-aeeb-2e1cf93a069c',
                      value:
                        'com.adobe.reactor.core.visitorTracking.pagesViewed',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a16ab78b-09a6-4359-bb8f-85ee912c64c0',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '5fbb06e6-95e6-40f2-9046-9e7bd9c20aaa',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ed743afe-b8ae-4cd3-9ad7-621a7f81c17f',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '9e9e6332-f4e7-4967-8ad8-c1e4ba61375e',
                      value:
                        'Contains data on user navigation, interaction and time spent on the website and its sub-pages - This data is used to optimise the relevance of advertisements and for statistical purposes.',
                      component: '_table_col',
                    },
                    {
                      _uid: '7d9c4022-0062-41d8-b5af-7e6c714dac97',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'ee1ea837-2f78-4d4c-8c34-b0192a99395a',
                  body: [
                    {
                      _uid: '059687e3-5a15-4d73-85c8-2d4bfe1e296c',
                      value:
                        'com.adobe.reactor.core.visitorTracking.sessionCount',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ba783e96-d010-4967-afac-8ff64b8b656f',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '74ff9c86-05c5-44e7-9571-1d97adf24e13',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '642527c6-3337-4b9c-a34c-f05322924f8a',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd161122c-409c-4ff9-970d-9c550761960a',
                      value:
                        'Contains data on user navigation, interaction and time spent on the website and its sub-pages - This data is used to optimise the relevance of advertisements and for statistical purposes',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd0fecdd7-1983-45cc-9861-98f89fdf4dee',
                      value: 'localStorage',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '2aa7665c-3a34-4cd1-976c-ff707fd46cde',
                  body: [
                    {
                      _uid: '9769fcb3-eb57-4d8f-9b98-a60f8afd90f8',
                      value:
                        'com.adobe.reactor.core.visitorTracking.trafficSource',
                      component: '_table_col',
                    },
                    {
                      _uid: '07fe500e-e37a-49b4-8d11-654b9c75b2c6',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b41768b8-5b46-44b7-896a-b6ee93745854',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '44161157-9ade-4ee4-9189-a7887ffe1ccf',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '6a3d906e-f66e-4567-b4ba-1908dd558a2c',
                      value:
                        "Used by the website's owners to identify how the visitor accessed the website - This is used for statistical purposes.",
                      component: '_table_col',
                    },
                    {
                      _uid: '35731752-5cf5-4044-86ce-b782ee24923f',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '58d14f23-a91d-452c-98c4-eefcccbd906d',
                  body: [
                    {
                      _uid: 'e6e484bd-4830-4953-aec9-8c49a604f3cb',
                      value: 'com.adobe.reactor.core.maxFrequency.*.second',
                      component: '_table_col',
                    },
                    {
                      _uid: 'bdd986a9-3e76-46ec-bd39-13577685fcdf',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a1cd411f-a822-428f-b3d8-4270ea836230',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '6c072755-e40d-4911-8a1d-4ad5b9c8d6ef',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '27075437-005c-40a4-bbb9-47d860d6aec3',
                      value:
                        'Enables tag manager to specify the number of times a condition will return true',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e15b2b98-439b-4686-bba3-582c01932853',
                      value: 'localStorage',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '4c2f9c09-58c3-452c-b714-90dda4031b65',
                  body: [
                    {
                      _uid: '454530d2-fcb2-412b-ae99-43187d491195',
                      value: 'com.adobe.reactor.dataElements.Analytics ID ',
                      component: '_table_col',
                    },
                    {
                      _uid: '57c8797d-73d0-42d9-b666-7f6d66a6a11c',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f22e9daa-79a7-4a8e-b924-c7974c428939',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c1b6e402-7682-4fdc-b54c-93267b3262ff',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '7d8ea944-a7e2-4ddd-bed1-dcb2e415f5c1',
                      value:
                        'Stores cinch user ID so it can be used by Adobe Analytics. Only stores data if the user is logged in.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fa9a2c16-f55d-40ec-a430-f66385a2fbfe',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '63d2fc3e-9f9c-4d6c-882b-dd4e1707e224',
                  body: [
                    {
                      _uid: '8e1bb686-aff0-4792-ada4-ab769c92cca6',
                      value: '_ga',
                      component: '_table_col',
                    },
                    {
                      _uid: '9f564da3-73a4-48d0-961a-c565474003d5',
                      value: 'Google',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b1c3d883-c42b-462e-bfff-de3738db9a07',
                      value:
                        'https://policies.google.com/technologies/partner-sites',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a94eda67-6245-423b-b8e5-ca00a5bbb481',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '54249cc4-ec47-418b-b564-99413cfe8c7a',
                      value: 'ID used to identify users',
                      component: '_table_col',
                    },
                    {
                      _uid: '9f884484-5e52-40e6-96ac-9270799abcf8',
                      value: '2 years',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '1a23426d-94ca-4393-8f54-38298d725ac2',
                  body: [
                    {
                      _uid: '122f71ea-5be8-4289-9931-c898142d956d',
                      value: '_gid',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a706ab88-b621-4f44-90e6-15cc20601555',
                      value: 'Google',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ddccb2c2-aaa3-42bd-b311-296a0b0d1ab8',
                      value:
                        'https://policies.google.com/technologies/partner-sites',
                      component: '_table_col',
                    },
                    {
                      _uid: '9383bf02-ffb4-4690-aa70-d12329579e33',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'caa40bf1-6e87-429f-bad4-8b9ec0029fe8',
                      value:
                        'ID used to identify users for 24 hours after last activity ',
                      component: '_table_col',
                    },
                    {
                      _uid: '1c63d3e8-cbe3-402f-add0-36251b6d83a6',
                      value: '24 hours',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '9b3395c8-ade0-4e13-baa0-eb9c7314e42c',
                  body: [
                    {
                      _uid: '0e1bdbb9-7da1-4535-a7d3-b7791f70a723',
                      value: '_gat',
                      component: '_table_col',
                    },
                    {
                      _uid: '8d1f183f-9e98-4326-9e9c-1f1198d8d96c',
                      value: 'Google',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c541338c-b35a-4947-ac99-89c76a80dea9',
                      value:
                        'https://policies.google.com/technologies/partner-sites',
                      component: '_table_col',
                    },
                    {
                      _uid: 'bd8a9642-9b76-40ef-b0af-d0f7c8165b0f',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '434cc906-e103-491a-9f75-576750b571c5',
                      value:
                        'used to limit the number of requests that have to be made to doubleclick.net',
                      component: '_table_col',
                    },
                    {
                      _uid: '47fc071a-5fbb-4395-801b-884cabe7b5bb',
                      value: '1 minute',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '06ba9cf1-984c-4bda-a104-6522152fd173',
                  body: [
                    {
                      _uid: 'c7aae7e9-f62b-486d-a6a1-de453e1350be',
                      value: '_ga_*',
                      component: '_table_col',
                    },
                    {
                      _uid: 'da7c0dbe-d13d-40eb-b7dd-9d49e2ddc037',
                      value: 'Google Analytics',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e130d92c-3156-414f-a049-bebfdc92e8f3',
                      value:
                        'https://developers.google.com/analytics/devguides/collection/gtagjs/cookie-usage',
                      component: '_table_col',
                    },
                    {
                      _uid: '3b200f0a-f6c1-4b96-a786-1a516ccf9acc',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '881d5943-bcc4-470c-ae69-aa07b17c3d93',
                      value: 'Used to persist session state.',
                      component: '_table_col',
                    },
                    {
                      _uid: '9b88b34d-3ff3-43ec-adfc-ae7c12d825a0',
                      value: '2 years',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'ccd165a6-f625-4315-bb0e-3cb3b3c1ef4e',
                  body: [
                    {
                      _uid: 'cf8d8a6f-01b1-4bf9-aa0c-4578d1fb23f1',
                      value: 's_ppv',
                      component: '_table_col',
                    },
                    {
                      _uid: '0ff74d73-555e-49e0-b297-dfb30212c10a',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e9006d1a-6c26-4784-8a81-bf0316d7ce4b',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '5c3512e0-f1bc-4697-9da0-5d0030aa3bb2',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd2e95f2b-7c2b-4db8-9e34-1f4766cea3b6',
                      value:
                        'Stores information on the percentage of the page displayed',
                      component: '_table_col',
                    },
                    {
                      _uid: '670fb5f1-03c2-4614-82ee-a9d45a9cca70',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'c0eb4788-86f0-4cd1-97e2-b9df5dec2c1e',
                  body: [
                    {
                      _uid: '68f668ca-7c53-4dcd-8fb4-0f6e4ad69f82',
                      value: 's_ppn',
                      component: '_table_col',
                    },
                    {
                      _uid: '52213b5f-28c6-461d-b677-3dd60042e688',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '9ffbf1b8-ee61-4dd4-a2cb-6555d7310eaf',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a87d98b2-7686-4ee2-b814-b825c1298993',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '84a4754e-ec02-4378-b120-ac0d4782ac8f',
                      value:
                        'Retrieves the previous page name to support the s_ppv cookie plugin',
                      component: '_table_col',
                    },
                    {
                      _uid: '8cca49e9-1eed-416a-998f-2f178babb2e5',
                      value: '1 hour',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '5aefdc05-760b-4a15-829a-10b41b643eaa',
                  body: [
                    {
                      _uid: '20f9d391-5500-4b78-a4f5-2616b84455a0',
                      value: 's_ptc',
                      component: '_table_col',
                    },
                    {
                      _uid: '8565e861-f4fa-46e8-b3a0-923d7a7c93f3',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'bb09763a-48fb-4a19-a24b-910986d8de12',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '05d56a11-19ef-4658-939d-21b014fadd9d',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '24256d2b-e820-4e77-97bb-7765fb381c47',
                      value: 'track how quickly our pages are loading.',
                      component: '_table_col',
                    },
                    {
                      _uid: '2798ccdf-3cef-402d-a9c4-8f12dec99daa',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '8c25e715-a4b6-44f5-94f9-79d3540d0402',
                  body: [
                    {
                      _uid: 'f3ecf12e-5314-4271-b8f1-1d891d0cf0ab',
                      value: 's_tp',
                      component: '_table_col',
                    },
                    {
                      _uid: '976383a7-1c16-4db4-b285-a7dd6cb40126',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '24fcd0a4-49d0-4d70-b22b-222b02ae0366',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '26c6e49a-456b-4b6f-bd34-fb0d69efc253',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '1a0ffa4f-c980-4856-a395-f4080ad8d910',
                      value: 'Stores information required by the s_ppv cookie',
                      component: '_table_col',
                    },
                    {
                      _uid: '7a159109-8664-42d6-b97b-e660a003c4ef',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '4513e2f7-7819-4f65-a87b-1d8bc6ecae7a',
                  body: [
                    {
                      _uid: '6a82ab85-a1a4-45c5-bfc7-9953fd27b57f',
                      value: 's_vnum',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ac2c38d2-bebc-4784-babd-f218667d26ec',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '7c69ec3d-813d-4b50-8465-6750c0c324e1',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '4f9f7c2e-1e2a-4cf2-a9c5-0c61a838f205',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '59b7e35e-9095-4b58-8c5b-89aad2316177',
                      value: 'Stores the number of visits by a Unique Visitor.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ea6c5ef3-8760-4c65-8549-f6ea96e8782a',
                      value: '30 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '7b7eef0f-be9f-49ea-a9dc-8c368573b300',
                  body: [
                    {
                      _uid: 'aed391c8-7216-46dd-a554-3faba6f16483',
                      value: 'sc_dslv',
                      component: '_table_col',
                    },
                    {
                      _uid: '78ae50a1-332a-42a8-9ae1-65913ca804e9',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '1b4c5338-81f9-4077-a46f-320c6601cfd0',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a46e6ef9-ea5a-4de6-94ca-6f919808512e',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'dc0e7d15-47a6-4e95-9198-a24e3299b717',
                      value:
                        'Determines the number of days since a user last visited your site, and captures this information in an Analytics variable.',
                      component: '_table_col',
                    },
                    {
                      _uid: '41d1f7e2-25df-4d0a-a408-bb8815dd4b83',
                      value: '3 years',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'a6978c75-70e9-42ef-a9f0-0cec82a477cd',
                  body: [
                    {
                      _uid: '2e042df4-de34-4fad-9aaa-ce7df441618a',
                      value: 'everest_session_v2',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ad70e89d-3f63-4ea4-adc3-1acd4fb1c18d',
                      value: 'Adobe Advertising',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd549e1c5-ee12-4ee7-983e-bd4d41eb6f96',
                      value:
                        'https://experienceleague.adobe.com/docs/core-services/interface/administration/ec-cookies/cookies-advertising-cloud.html?lang=en#cookie-name%3A-everest_session_v2',
                      component: '_table_col',
                    },
                    {
                      _uid: '891f63ef-6164-450b-8c1a-166d7ad26d50',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '7999d178-ebbd-4fd6-bd00-2d2f5e2eb140',
                      value:
                        'Used to display personalised and relevant ads to the users and measure the efficiency of a campaign.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ae1d49f5-4ec5-4a3b-a8bc-0c51bb914dd7',
                      value: '',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'a367f5e0-5ee1-4316-a191-5fbc9e07ef75',
                  body: [
                    {
                      _uid: '2967f02b-801c-4cf5-999a-754b035f0434',
                      value: 'sc_dslv_s',
                      component: '_table_col',
                    },
                    {
                      _uid: '160aa2ec-ef8c-4024-ac07-2eaa7219bab6',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'aa91f9fc-0835-4603-a10a-a3272ed47b59',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'df888617-a331-4b50-9357-82960a3d169d',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '5ce5e3a5-c18b-4936-8fa3-f0db77b4ffdf',
                      value:
                        'Determines the number of days since a user last visited your site, and captures this information in an Analytics variable.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f8153a4f-e83d-4d52-a56d-0171983b7f36',
                      value: '30 minutes',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '44b2b9f6-75c6-4d66-8859-2e9e8abbde89',
                  body: [
                    {
                      _uid: '72326845-62e4-4466-b27e-ec3e7a6489a6',
                      value: 'ttcsid_C7EL8KCRNSL79GUTBST0',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd8f9297e-8cd7-44a8-bad6-eb7d9916d325',
                      value: 'TikTok',
                      component: '_table_col',
                    },
                    {
                      _uid: '441eb0f8-68a7-48b9-9c09-87fd034112fe',
                      value:
                        'https://www.tiktok.com/legal/privacy-policy-eea?lang=en',
                      component: '_table_col',
                    },
                    {
                      _uid: '4d03639c-8907-4074-990b-d3acf4917ca5',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '875b1540-705e-400e-9771-8b04460fc085',
                      value: 'Traffic measurement & audience creation',
                      component: '_table_col',
                    },
                    {
                      _uid: 'de409873-7056-4ac1-930e-a3a37d17793f',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '8af1daf9-5dde-4864-b139-8ee41d9c2ff9',
                  body: [
                    {
                      _uid: 'fb9cca74-9ae0-411d-8990-c6bbe6d63b7d',
                      value: 'tt_enable_cookie',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fe8f8472-28c9-4f44-82e4-b9a834a766bc',
                      value: 'TikTok',
                      component: '_table_col',
                    },
                    {
                      _uid: '6f2e5165-f6a9-4f41-bc61-1229f9e0a15d',
                      value: 'https://ads.tiktok.com/help/article?aid=10007540',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e267905e-7f2e-4c91-9798-3fca7afd1406',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '1216f23f-1d1b-4921-8e95-6f4453118d24',
                      value:
                        'A third-party browser session cookie; one cookie is used for all accounts',
                      component: '_table_col',
                    },
                    {
                      _uid: 'bbf3bb44-a6c8-4eff-9493-6aa246c46811',
                      value: '2 years',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'a06030d7-a001-4842-b6d5-16b787b3fc17',
                  body: [
                    {
                      _uid: '01ac7b2e-6523-4935-bc83-1402395cecfb',
                      value: '_ttp',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fb9c37a6-8c22-4301-a947-03f333336167',
                      value: 'TikTok',
                      component: '_table_col',
                    },
                    {
                      _uid: '1d86b0fa-3ab8-4106-b757-25c32d543bfe',
                      value: 'https://ads.tiktok.com/help/article?aid=10007540',
                      component: '_table_col',
                    },
                    {
                      _uid: '577bba19-7abf-4763-acc7-fdc3b167011d',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'dec7e3f6-da46-4e08-a5d4-e1c13cca463e',
                      value:
                        "To measure and improve the performance of your advertising campaigns and to personalize the user's experience (including ads) on TikTok",
                      component: '_table_col',
                    },
                    {
                      _uid: '1e81e2ce-2c11-4846-bdef-d4205b573b80',
                      value: '13 months',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '52840d4e-052b-451a-92a3-d5d1279a1a75',
                  body: [
                    {
                      _uid: '34b64abd-3ec5-40d9-9dac-eed8e3f46d07',
                      value: 'ttcsid',
                      component: '_table_col',
                    },
                    {
                      _uid: '3113d1f0-5ea0-43a3-aff5-efc5edfe782a',
                      value: 'TikTok',
                      component: '_table_col',
                    },
                    {
                      _uid: '77feda7e-6260-4935-ba3d-75893c4a028f',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '0021b783-dc86-4db2-9480-95607b82597d',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'eb7fd665-b161-4489-89b9-86b08d3ce798',
                      value:
                        'This cookie is essential for maintaining user sessions and ensuring core site functionality.',
                      component: '_table_col',
                    },
                    {
                      _uid: '7bbb8994-2479-4c93-980d-709d55d89080',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'c81e50e9-5943-4c10-9da9-45cc943c265b',
                  body: [
                    {
                      _uid: 'fb7c64c1-91a5-4ab5-b5c0-a04c54ee2d02',
                      value: 'receive-cookie-deprecation',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f1680cd7-05ff-4684-9d4e-3e915ab9c2cc',
                      value: 'doubleclick.net',
                      component: '_table_col',
                    },
                    {
                      _uid: '47ec6f6e-a27e-4304-a005-1cee33c9b025',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ebf871db-54e7-4a0b-a2c4-669622bc1a74',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '2d173408-0b38-4e0d-be4f-19b1639ab2a3',
                      value:
                        'Google sets this cookie to enable Privacy Sandbox testing and preview how site behaviour and functionality work without third-party cookies.',
                      component: '_table_col',
                    },
                    {
                      _uid: '3f4e2820-67e9-4fab-88ae-7e53d96ff22a',
                      value: '6 months',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'aac47828-522d-4c94-8ef4-af9c0a91331e',
                  body: [
                    {
                      _uid: '54058c57-7ff9-4db5-9be5-6c59d4c081bc',
                      value: 'SRM_B',
                      component: '_table_col',
                    },
                    {
                      _uid: '3c3869c9-dbcc-4456-88ca-68c828b033a1',
                      value: 'Bing',
                      component: '_table_col',
                    },
                    {
                      _uid: '81c759c8-368c-4db0-9b4f-ef0eff168009',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '3b012875-5e94-4d26-920f-314ae1a251d9',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '17de0831-930c-42a7-88fe-480e7d9376ff',
                      value:
                        'Identifies unique web browsers visiting Microsoft sites.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e662847f-46c6-40c6-bb65-e5679a503ac5',
                      value: '1 year 24 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'f844731f-71fc-4783-ac6e-fa1981bae116',
                  body: [
                    {
                      _uid: '3a4c7d4c-64d8-4b10-9b97-de1e3dcc8822',
                      value: '_uetsid',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd82d0e96-7faa-46a6-a71f-d49e81c52c92',
                      value: 'Bing',
                      component: '_table_col',
                    },
                    {
                      _uid: '737280fe-255d-43b2-9c14-38c2001f5568',
                      value:
                        'https://cookiedatabase.org/cookie/bing-ads/_uetsid/',
                      component: '_table_col',
                    },
                    {
                      _uid: '5f085868-5176-4453-9e1c-429af444c645',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a7981fde-2d36-4935-97de-c909bcaf1291',
                      value: 'to store and track visits across websites.',
                      component: '_table_col',
                    },
                    {
                      _uid: '1b0bf76b-3e4e-4aba-8038-9de62139a408',
                      value: '30 minutes after the browsing session ends',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '3d22c97f-ec20-413a-acd7-ec9445486d6a',
                  body: [
                    {
                      _uid: '2a19d707-9e79-4d2f-8b08-77170be6d42b',
                      value: '_uetvid',
                      component: '_table_col',
                    },
                    {
                      _uid: '627931b6-79d7-46c6-93ab-93e987822cb1',
                      value: 'Bing',
                      component: '_table_col',
                    },
                    {
                      _uid: '1c01f0db-01f3-412b-a126-17583a696175',
                      value:
                        ' https://cookiedatabase.org/cookie/bing-ads/_uetvid/',
                      component: '_table_col',
                    },
                    {
                      _uid: '61b557ec-2fc4-4db1-b1be-5c3a1d9231da',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a02f0aba-4ea6-4868-9edb-38a5094d806b',
                      value: 'to store and track visits across websites.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f395a852-bee8-46f2-aa9c-843097e6faae',
                      value: 'Maximum of 16 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'ddcaecf0-cc88-4512-945b-9f730550a926',
                  body: [
                    {
                      _uid: '7105205a-48dc-434d-ab82-e21edf91f222',
                      value: 'crm_enrichment:email',
                      component: '_table_col',
                    },
                    {
                      _uid: 'cd3a7b48-f325-467f-b4a8-80ae00b471a3',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '21d67363-cda9-4ddc-bef0-f20896e6122d',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'cb302032-4aad-4491-a049-4eac5e225e2e',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '6ba90141-18a3-4140-b753-43980fa367e5',
                      value:
                        'Uses email entered into the Part Exchange form or Search Alerts form to help match Segment profiles to Customer.io profiles. ',
                      component: '_table_col',
                    },
                    {
                      _uid: '4fba28ec-4d17-4f36-8447-399f29569f4d',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
              ],
              thead: [
                {
                  _uid: 'a466f25c-a531-4722-a13e-c188ac3d9ef4',
                  value: 'Cookie ID',
                  component: '_table_head',
                },
                {
                  _uid: 'de040791-eecc-4840-8b3b-6a8ef8ebf111',
                  value: 'Company Name',
                  component: '_table_head',
                },
                {
                  _uid: '20ff4d79-215c-41d6-a5df-9a291fd58229',
                  value: 'Link',
                  component: '_table_head',
                },
                {
                  _uid: '440c747c-ba76-4afd-950a-ff87831522af',
                  value: '1st Party or 3rd Party',
                  component: '_table_head',
                },
                {
                  _uid: 'bdc49c7f-86f4-4361-b648-65cf7a4131c2',
                  value: 'Use',
                  component: '_table_head',
                },
                {
                  _uid: 'c6b8bbdc-9734-4ba9-9fe3-5aab0210b756',
                  value: 'Lifespan',
                  component: '_table_head',
                },
              ],
              fieldtype: 'table',
            },
            heading: 'Marketing and Analytics',
            component: 'TableSection',
            description: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third-party advertisers.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Accepting Marketing and Analytics means your data (including anonymous IDs or other encrypted identifiers) may be shared with the third parties specified below, including through the use of web beacons and tracking pixels.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            dontShowTableHeader: true,
          },
        ],
        deleteSection: [
          {
            _uid: 'db466318-341a-4128-8f88-9a435695d55d',
            title: 'Deleting cookies',
            pcNote: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'text',
                      text: 'You may update your cookie preferences at any time and they will be deactivated on your device. If you wish to delete the cookies manually, you can do this via your browser Privacy settings. If you are using the cinch app, you can delete browsing data including cookies by using the Storage or App settings on your device.',
                    },
                  ],
                },
              ],
            },
            macNote: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'text',
                      text: '',
                    },
                  ],
                },
              ],
            },
            component: 'DeleteCookiesSection',
            pcInstructions: [],
            macInstructions: [],
          },
        ],
      },
    ],
  },
  slug: 'cookie-policy',
  full_slug: 'policies/cookie-policy',
  sort_by_date: null,
  position: -160,
  tag_list: [],
  is_startpage: false,
  parent_id: 170758293,
  meta_data: null,
  group_id: '3ef71527-4b3b-4c97-aa8e-a12516cae039',
  first_published_at: '2022-08-05T14:35:58.000Z',
  lang: 'default',
  path: '',
  alternates: [],
}
